// @ts-nocheck
import { content } from '../content/content.js';
import { publicEnv } from './env.js';
import { getFormReadiness, getPublishedKnowledgeMaterials, getPublishedManufacturers, getPublishedModels, getSoftwareProduct, getVerifiedCompatibilityRecords } from '../content/repository.js';

export const productionGates = Object.freeze({
  contacts: content.contacts.some(contact => contact.verified),
  privacy: content.consents.some(consent => consent.approved),
  forms: content.forms.every(form => getFormReadiness(form.id).ready),
  erp: Boolean(getSoftwareProduct('anlexx-erp')),
  knowledge: getPublishedKnowledgeMaterials().length >= 3,
  manufacturers: getPublishedManufacturers().length > 0,
  equipmentData: getPublishedModels().length > 0,
  tracoraCompatibility: getVerifiedCompatibilityRecords().length > 0,
  heroMediaRights: content.media.find(media => media.id === 'media-hero-main')?.rightsConfirmed === true,
});

export const blockedForProduction = Object.entries(productionGates)
  .filter(([, ready]) => !ready)
  .map(([gate]) => gate);

export function assertProductionReady() {
  const formGatesBlock = publicEnv.VITE_FORMS_ENABLED
    && blockedForProduction.some(gate => ['privacy', 'forms'].includes(gate));
  if (import.meta.env.PROD && formGatesBlock) {
    return { ready: false, blocked: blockedForProduction };
  }
  return { ready: true, blocked: blockedForProduction };
}
